// GuidePreview.tsx — DEV ONLY. Renders every guide-presence tile at once so the
// images + captions + quotes can be reviewed without triggering each hook in the
// wild (they're event-gated by design). Shown in Settings under the dev toggle.
import { GuidePresence } from '@/flows/guide/GuidePresence';
import { GUIDE_MESSAGES, type GuideHook } from '@/data/guideMessages';
import type { GuideSelection } from '@/services/guidePresence';

const HOOKS: GuideHook[] = [
  'H1_welcome',
  'H2_return',
  'H3_reallyHard',
  'H4_actBoundary',
  'H5_mastery',
  'H6_checkinInvite',
  'H7_overPacing',
  'H8_milestone',
  'H9_toolUnlocked',
  'H10_toolkitInvite',
  'H11_encouragement',
];

export function GuidePreview() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
      {HOOKS.map((hook) => {
        const msg = GUIDE_MESSAGES[hook];
        const quote = (msg.quotePool ?? msg.quoteByAct?.act1)?.[0];
        const sel: GuideSelection = { hook, clipId: msg.clipId, caption: msg.caption, quote };
        return (
          <div key={hook}>
            <div style={{ fontFamily: 'Inter, system-ui, sans-serif', fontSize: 10, fontWeight: 700, letterSpacing: '0.08em', textTransform: 'uppercase', color: 'var(--ink-soft)', margin: '4px 2px 6px' }}>
              {hook}
            </div>
            <GuidePresence selection={sel} onClose={() => {}} />
          </div>
        );
      })}
    </div>
  );
}
